import { ColumnMain } from "../column-main";
import { Column } from "../column";
import { Trans } from "@lingui/macro";
import { Tag } from "antd";
import React from "react";

const UsersListModel = (): ColumnMain => {

    const columns: Array<Column> = new Array();
    columns.push({ key: 'loginName', filter: true, sorter: true, title: <Trans>Login Name</Trans> });
    columns.push({ key: 'email', filter: true, sorter: true, title: <Trans>Email</Trans> });
    columns.push({
        key: 'roleName',
        dataIndex: 'roleName',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>EUDR_ADMIN</Trans>,
                value: 'EUDR_ADMIN',
            },
            {
                label: <Trans>EUDR_MSC_ADMIN</Trans>,
                value: 'EUDR_MSC_ADMIN',
            },
            {
                label: <Trans>EUDR_SUPPL_ADMIN</Trans>,
                value: 'EUDR_SUPPL_ADMIN',
            },
            {
                label: <Trans>EUDR_SUPPL_USER</Trans>,
                value: 'EUDR_SUPPL_USER',
            }
        ],
        sorter: true,
        width: 200,
        title: <Trans>Role</Trans>,
        render: (value, row) => {
            const roleName = row && Array.isArray(row.roles) && row.roles.length > 0 ? row.roles[0]['roleName'] : "";
            let color = 'gray';
            let transText = roleName;

            if (roleName === 'EUDR_ADMIN') {
                color = 'red';
                transText = <Trans>EUDR_ADMIN</Trans>;
            } else if (roleName === 'EUDR_MSC_ADMIN') {
                color = 'volcano';
                transText = <Trans>EUDR_MSC_ADMIN</Trans>;
            } else if (roleName === 'EUDR_SUPPL_ADMIN') {
                color = 'blue';
                transText = <Trans>EUDR_SUPPL_ADMIN</Trans>;
            } else if (roleName === 'EUDR_SUPPL_USER') {
                color = 'green';
                transText = <Trans>EUDR_SUPPL_USER</Trans>;
            }

            return (
                <Tag color={color} key={roleName}>
                    {transText}
                </Tag>
            );
        }
    });

    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 200, sorter:true,title:<Trans>Created By</Trans>});
    
    return {
        columns: columns,
        url: "/resource/user"
    };

}
export default UsersListModel();
